const iconWallet = `
  <svg width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
      <path d="M0 0h30v30H0z"/>
      <g class="icon-color" fill-rule="nonzero" transform="translate(4 5)" fill="#038AB7">
        <path d="M16.878 14.88c-1.551 0-2.813-1.292-2.813-2.88 0-1.588 1.262-2.88 2.813-2.88h3.282v-4.8c0-.265-.21-.48-.469-.48H2.344C1.569 3.84.938 3.194.938 2.4c0-.794.631-1.44 1.406-1.44h12.659v1.92h.937V.48c0-.265-.21-.48-.469-.48H2.344C1.052 0 0 1.077 0 2.4v14.4c0 1.853 1.472 3.36 3.282 3.36h16.409c.259 0 .469-.215.469-.48v-4.8h-3.282z"/>
        <path d="M21.137 10.08h-4.166c-1.02 0-1.851.807-1.851 1.8s.83 1.8 1.851 1.8h4.166c.256 0 .463-.202.463-.45v-2.7c0-.248-.207-.45-.463-.45z"/>
      </g>
    </g>
  </svg>
`

export default iconWallet
